export function init() {
  const alertBoxCloseElem = document.querySelectorAll('.close');
  for (let i = 0; i < alertBoxCloseElem.length; i++) {
    alertBoxCloseElem[i].addEventListener('click', closeAlert);
  }
  function closeAlert(event) {
    const element = event.currentTarget;
    if (element) {
      const alertBoxToBeClosed = element.closest('.alert');
      if (alertBoxToBeClosed) {
        alertBoxToBeClosed.classList.add('opacity-0');
        alertBoxToBeClosed.classList.add('d-none');
      }
    }
  }
}

export default init;
